import { AUTH_CONFIG } from './config.token';
import { AuthConfig } from './models';
import { Provider } from '@angular/core';

export function provideAuth(config: AuthConfig): Provider {
  return {
    provide: AUTH_CONFIG,
    useValue: config,
  };
}
